import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { ROUTE_ROOT } from './constants';
import PublicRoute from './PublicRoute';

// Screens/Pages

import NotFound from '../screens/404';
import Home from '../screens/Home/index';
import Footer from './Footer/';

import './styles.scss';

export default function Navigation() {
    return (
        <Router>
            <Switch>
                <PublicRoute exact path={ROUTE_ROOT}>
                    <Home />
                </PublicRoute>
                <PublicRoute exact path="/*">
                    <NotFound />
                </PublicRoute>
            </Switch>
            <Footer />
        </Router>
    );
}
